import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, Subscription } from 'rxjs';
import { showAnimation } from 'src/animations';
import { PaginationPage, PaginationResponse } from 'src/app/classes';
import { EMailAudit } from '../../../classes';
import { MailService } from '../../../services/mail.service';
import { MailInboxComponentService } from '../../main/mail-inbox/mail-inbox-component-service';

@Component({
  selector: 'app-recover-seen-mail-dialog',
  templateUrl: './recover-seen-mail-dialog.component.html',
  styleUrls: ['./recover-seen-mail-dialog.component.css'],
  animations: [ showAnimation ]
})
export class RecoverSeenMailDialogComponent implements OnDestroy, OnInit {

  page: PaginationPage = { 'pageNumber': 1, 'pageSize': 10 };

  private _mails = new BehaviorSubject([]);
  mails$ = this._mails.asObservable();

  private _loading = new BehaviorSubject(false);
  loading$ = this._loading.asObservable();

  totalItems = 0;

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) private _account: 'assignment' | 'incident',
    private _mailInboxComponentService: MailInboxComponentService,
    private _mailService: MailService,
    private _dialogRef: MatDialogRef<RecoverSeenMailDialogComponent>
  ) { }

  close = () => this._dialogRef.close();

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    if (this._account) this.loadMails();
  }

  loadMails() {
    this._loading.next(true);
    this._mailService.loadMailsFromMailInbox(this._account, this.page).subscribe({
      'next': (response: PaginationResponse<EMailAudit[]>) => {
        this.totalItems = response.totalItems;
        this._mails.next([...(response.page.pageNumber === 1 ? [] : this._mails.value), ...response.content]);
        this.page = response.page;
      },
      'complete': () => this._loading.next(false)
    });
  }

  loadMore() {
    this.page.pageNumber++;
    this.loadMails();
  }

  recoverMail(mail: EMailAudit){
    this._mailService[this._account === 'assignment'? 'markAssignmentMailAsNotSeen': 'markIncidentMailAsNotSeen'](mail.messageId).subscribe({
      next: () => this._mailInboxComponentService.checkForNewMails()
    });
  }

}
